import { Component, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from "rxjs";

@Component({
  selector: "app-technical-info-question",
  templateUrl: "./technical-info-question.component.html",
  styleUrls: ["./technical-info-question.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TechnicalInfoQuestionComponent),
      multi: true,
    },
  ],
})
export class TechnicalInfoQuestionComponent<T> implements ControlValueAccessor {
  @Input() question: string;
  @Input() options: { displayName: string; value: T }[] = [
    { displayName: $localize`:@@general.yes:Yes`, value: <any>true },
    { displayName: $localize`:@@general.no:No`, value: false },
  ];
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = true;
  @Input() displayError: boolean = false;
  currentValue: T;
  currentValueChange: Subject<T> = new Subject<T>();

  constructor() {}

  onChangeValue(newValue: T) {
    this.currentValue = newValue;
    this.currentValueChange.next(newValue);
  }

  writeValue(obj: T): void {
    this.currentValue = obj;
  }
  registerOnChange(fn: any): void {
    this.currentValueChange.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched();
  }
  private onTouched = () => null;

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
